import React, { useCallback, useEffect, useMemo, useState, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
    Text,
    Flex,
    Card,
    CardHeader,
    CardBody,
    Stack,
    Button,
    FormControl,
    useColorModeValue
} from "@chakra-ui/react";

import { trafficViolationService } from "services/trafficViolationService";
import { useCustomToast } from "components/CustomToast/CustomToast";
import { ROUTES } from "constants/routes-path";
import Loading from "components/Loading/Loading";
import { FileAttachmentInput } from "../../../components/FileAttachmentInput/FileAttachmentInput";

const TrafficViolationConfirmPaymentForm = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const showToast = useCustomToast();
    const [formData, setFormData] = useState(undefined);
    const attachmentRef = useRef(undefined);
    const [fileAttachmentName, setAttachmentFileName] = useState(null);
    const [initialAttachmentFile, setInitialAttachmentFile] = useState(null);
    const [inputError, setInputError] = useState({});
    const translationKey = "traffic-violation";
    const formTranslationKey = `${translationKey}.form`;
    const textColor = useColorModeValue("gray.700", "white");
    const cardSpacing = "20px";

    const ids = useMemo(() => ({
        files: "files"
    }), []);

    const initFormData = () => {
        return {
            [ids.files] : {
                value: "",
                validations: [ ]
            }
        }
    }

    const fetchData = async () => {
        try {
            const initialForm = initFormData();
            setFormData(initialForm);
        } catch (err) {
            showToast({ title: t(err), status: "error" });
            redirectToList();
        }
    }

    const redirectToList = () => {
        navigate(ROUTES.transportManagementPath + ROUTES.trafficViolations);
    }

    const isFormInvalid = () => {
        console.log(attachmentRef);
        if (attachmentRef?.current?.getFile()) {
            return false
        }
        return true;
    };

    const toFormData = () => {
        const data = new FormData();
        data.files = formData[ids.files].value;
        return data;
    };

      useEffect(() => {
        fetchData();
      }, []);

    const handleUpload = async () => {
        if (isFormInvalid()) return;
        try {
            const data = toFormData();
            await trafficViolationService.confirmPaymentCnab(data);
            showToast({ title: t("traffic-violation.messages.success.upload-file"), status: "success" });
            redirectToList();
        } catch (err) {
            showToast({ title: t(err), status: "error" });
        }
    }

    return (
        <Flex direction="column" pt={{ sm: "125px", lg: "75px" }}>
            <Card overflowX={{ sm: "scroll", lg: "hidden" }}>
                <CardHeader px="22px" mb="24px">
                    <Flex direction="column">
                        <Text color={textColor} fontSize="lg" mb="6px">
                            <Text as="span" fontWeight="normal">
                                {t("traffic-violation.upload-files")}
                            </Text>
                        </Text>
                    </Flex>
                </CardHeader>

                <CardBody px="22px">
                    {formData ? (
                        <Stack w="100%" direction="column" spacing={cardSpacing}>
                            <Stack alignSelf="center" spacing={cardSpacing} direction="row" minW="75%" alignItems="flex-start">
                                <FormControl isRequired isInvalid={inputError[ids.files]}>
                                    {/*foto*/}
                                    <FileAttachmentInput
                                        ref={attachmentRef}
                                        nameVariable={fileAttachmentName}
                                        acceptedTypes={['']}
                                        translationKey={translationKey}
                                        initialFile={initialAttachmentFile}
                                    />
                                </FormControl>
                            </Stack>
                            <Stack w="100%" direction="row" justify="space-between">
                                <Button w="125px" variant="no-effects" bg="gray.100" color="gray.700" fontSize="sm" fontWeight="bold" onClick={redirectToList}>
                                    <Text>
                                        {t("system.actions.cancel")}
                                    </Text>
                                </Button>
                                <Button
                                    w="125px"
                                    variant="dark"
                                    fontSize="sm"
                                    fontWeight="bold"
                                    onClick={handleUpload}>
                                    {t("system.actions.send")}
                                </Button>
                            </Stack>
                        </Stack>
                    ) : (
                        <Loading h="300px" w="100%" />)}
                </CardBody>
            </Card>
        </Flex>
    );
}

export default TrafficViolationConfirmPaymentForm